<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.products'), $t('text.list')]">
        <span v-if="Permit.canActions('productManage')">
          <el-button
            type="success"
            size="mini"
            @click="$router.push('/normal/pdm/products/new')"
            >+ {{ $t("text.create") }}</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="$router.push('/normal/pdm/products/new-import')"
            >{{ $t("action.import") }}</el-button
          >
        </span>
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="62"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar
          ref="recordsToolbar"
          :custom="!cardPattern"
          zoom
          class="table-toolbar"
        >
          <template v-slot:buttons>
            <el-checkbox
              v-if="cardPattern"
              v-model="checkAllDF"
              value="1"
              style="margin-right: 10px"
              @change="checkAll"
              >{{ $t("action.checkAll") }}</el-checkbox
            >
            <el-popconfirm
              v-if="Permit.canActions('productDelete')"
              :title="$t('prompt.confirmDelete')"
              @confirm="batchDelete"
              class="mgl10"
            >
              <el-button slot="reference" type="danger" size="mini">
                {{ $t("text.delete") }}
              </el-button>
            </el-popconfirm>

            <el-dropdown class="mgl10" @command="printTag">
              <el-button type="default" size="mini">
                {{ $t("action.printTag") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="printQrCodesDiv"
                  >有售价</el-dropdown-item
                >
                <el-dropdown-item command="printQrCodesNoPriceDiv"
                  >无售价</el-dropdown-item
                >
                <el-dropdown-item command="printSelectColorSizeDiv"
                  >选颜色规格</el-dropdown-item
                >
                <el-dropdown-item
                  v-for="(pt, index) of printTemplatesProduct"
                  :divided="index == 0 ? true : false"
                  :key="index"
                  :command="pt"
                  >{{ pt.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>

            <el-button
              class="mgl10"
              type="default"
              size="mini"
              @click="printBaseInfo"
              >{{ $t("action.printBaseInfo") }}</el-button
            >

            <el-dropdown class="mgl10" @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">{{
                  $t("action.downLoadChecked")
                }}</el-dropdown-item>
                <el-dropdown-item command="search">{{
                  $t("action.downLoadSearch")
                }}</el-dropdown-item>
                <el-dropdown-item command="checkedWithImg">{{
                  $t("action.downLoadCheckedWithImg")
                }}</el-dropdown-item>
                <el-dropdown-item command="searchWithImg">{{
                  $t("action.downLoadSearchWithImg")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-switch
              v-model="cardPattern"
              class="float-right"
              active-color="#B4B099 "
              inactive-color="#93745E"
              active-text="卡片模式"
              inactive-text="列表模式"
              @change="cardPatternChange"
            ></el-switch>
          </template>
        </vxe-toolbar>
      </sticky>
      <div v-if="cardPattern" :loading="loading">
        <div v-if="records && records.length != 0">
          <el-row :gutter="5">
            <el-col
              v-for="(row, rowIndex) in records"
              :key="row.id"
              :span="4"
              class="mgt10"
            >
              <el-card :body-style="{ padding: '0px' }">
                <div style="height: 280px">
                  <div class="image-div">
                    <div class="product-checkbox-div" style="z-index: 2">
                      <input
                        v-model="checkedProducts"
                        type="checkbox"
                        :value="row"
                        class="float-right"
                        @change="checkedProduct"
                      />
                    </div>
                    <thumbnail
                      :images="row.images"
                      width="auto"
                      height="100%"
                    />
                  </div>
                  <div class="pd5">
                    <el-row class="mgb5">
                      <el-col :span="23" class="overflow">
                        <span class="a" @click="showRow(row, rowIndex)">
                          {{ row.productNo }}
                        </span>
                        <span v-if="row.name != null" class="font10"
                          >({{ row.name }})</span
                        >
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12" class="overflow">
                        <div style="min-height: 21px">
                          {{ row.categoryName }}
                        </div>
                      </el-col>
                      <el-col
                        v-if="Permit.canActions('globalRentPrice')"
                        :span="12"
                        class="overflow right red"
                      >
                        {{ row.rentPrice | currency }}
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="14">
                        <span style="height: 28px; line-height: 28px">
                          <span
                            v-if="Permit.canActions('productManage')"
                            class="a font10 mgr8"
                            @click="editRow(row, rowIndex)"
                            >{{ $t("text.edit") }}</span
                          >
                          <el-popconfirm
                            v-if="Permit.canActions('productDelete')"
                            :title="$t('prompt.confirmDelete')"
                            @confirm="deleteRow(row)"
                          >
                            <span
                              slot="reference"
                              type="text"
                              class="a font10 mgr8"
                            >
                              {{ $t("text.delete") }}
                            </span>
                          </el-popconfirm>
                        </span>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div v-else class="noData">{{ $t("text.noData") }}</div>
      </div>
      <div v-else>
        <vxe-table
          :data="records"
          @checkbox-change="setSelected"
          @checkbox-all="setSelected"
          :checkbox-config="{ reserve: true }"
          :loading="loading"
          id="productsTable"
          row-id="id"
          ref="recordsTable"
          class="recordsTable"
          size="mini"
          resizable
          highlight-hover-row
          auto-resize
          :scroll-y="{ enabled: false }"
        >
          <vxe-table-column
            field="checkbox"
            type="checkbox"
            width="35"
          ></vxe-table-column>
          <vxe-table-column
            field="images"
            :title="$t('product.images')"
            width="80"
          >
            <template v-slot="{ row }">
              <thumbnail :images="row.images" width="80" />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="productNo"
            :title="$t('product.productNo')"
            min-width="120"
          >
            <template v-slot="{ row, rowIndex }">
              <span class="a" @click="showRow(row, rowIndex)">
                {{ row.productNo }}
              </span>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="name"
            :title="$t('text.name')"
            min-width="80"
          />
          <vxe-table-column
            field="categoryName"
            :title="$t('product.category')"
            min-width="80"
          />
          <vxe-table-column
            field="brand"
            :title="$t('product.brand')"
            min-width="80"
          />
          <vxe-table-column
            field="unit"
            :title="$t('product.unit')"
            min-width="60"
          />
          <vxe-table-column
            v-if="Permit.canActions('globalRentPrice')"
            field="rentPrice"
            :title="$t('product.rentPrice')"
            min-width="80"
          >
            <template v-slot="{ row }">
              {{ row.rentPrice | currency }}
            </template>
          </vxe-table-column>
          <vxe-table-column
            v-if="Permit.canActions('globalCostPrice')"
            field="costPrice"
            :title="$t('product.costPrice')"
            min-width="80"
          >
            <template v-slot="{ row }">
              {{ row.costPrice | currency }}
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="colors"
            :title="$t('product.color')"
            min-width="80"
          >
            <template v-slot="{ row }">{{ row.colors.join("，") }}</template>
          </vxe-table-column>
          <vxe-table-column
            field="sizes"
            :title="$t('product.size')"
            min-width="80"
          >
            <template v-slot="{ row }">{{ row.sizes.join("，") }}</template>
          </vxe-table-column>
          <vxe-table-column
            field="introduction"
            :title="$t('product.introduction')"
            min-width="100"
          >
            <template v-slot="{ row }">
              <raw-html-limit-number :content="row.introduction" :number="12" />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="action"
            :title="$t('text.action')"
            width="100"
            v-if="
              Permit.canActions('productManage') ||
              Permit.canActions('productDelete')
            "
            fixed="right"
          >
            <template v-slot="{ row, rowIndex }">
              <el-button
                v-if="Permit.canActions('productManage')"
                size="mini"
                type="text"
                @click="editRow(row, rowIndex)"
                >{{ $t("text.edit") }}</el-button
              >

              <el-popconfirm
                v-if="Permit.canActions('productDelete')"
                :title="$t('prompt.confirmDelete')"
                @confirm="deleteRow(row)"
                class="mgl10"
              >
                <el-button slot="reference" type="text" size="mini">
                  {{ $t("text.delete") }}
                </el-button>
              </el-popconfirm>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <div id="printQrCodesDiv" style="display: none">
      <div
        v-for="(cp, index) in checkedProducts"
        :key="cp.id"
        :style="
          'margin:0 auto 10px; width:200px; text-align:left; font-size: 14px;' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <div>
          <qrcode :value="qrCodes(cp)" :options="{ width: 100 }" :tag="'img'" />
        </div>
        <div style="padding-left: 10px">
          <div>{{ $t("product.productNo") }}：{{ cp.productNo }}</div>
          <div v-if="cp.name != null">{{ $t("text.name") }}：{{ cp.name }}</div>
          <div>{{ $t("product.category") }}：{{ cp.categoryName }}</div>
          <div>
            {{ $t("product.rentPrice") }}：{{ cp.rentPrice | currency }}
          </div>
          <div>
            {{ $t("product.salesPrice") }}：{{ cp.salesPrice | currency }}
          </div>
        </div>
      </div>
    </div>
    <div id="printQrCodesNoPriceDiv" style="display: none">
      <div
        v-for="(cp, index) in checkedProducts"
        :key="cp.id"
        :style="
          'margin:0 auto 10px; width:200px; text-align:left; font-size: 14px;' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <div>
          <qrcode :value="qrCodes(cp)" :options="{ width: 100 }" :tag="'img'" />
        </div>
        <div style="padding-left: 10px">
          <div>{{ $t("product.productNo") }}：{{ cp.productNo }}</div>
          <div v-if="cp.name != null">{{ $t("text.name") }}：{{ cp.name }}</div>
          <div>{{ $t("product.category") }}：{{ cp.categoryName }}</div>
        </div>
      </div>
    </div>

    <div id="printSelectColorSizeDiv" style="display: none">
      <div
        v-for="(cp, index) in combinationProducts"
        :key="index"
        :style="
          'margin:0 auto; width:400px; text-align:left; font-size: 18px;word-break: break-all;word-wrap: break-word' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <div style="clear: both">
          <div style="float: left; width: 100px">
            <qrcode
              :value="`${cp.productNo}|${cp.color}|${cp.size}|product|`"
              :options="{ width: 100 }"
              :tag="'img'"
            />
          </div>
          <div
            style="
              float: left;
              width: 260px;
              word-break: break-all;
              word-wrap: break-word;
              font-size: 14px;
            "
          >
            <div>{{ $t("product.productNo") }}：{{ cp.productNo }}</div>
            <div v-if="cp.categoryName != null">
              {{ $t("product.category") }}：{{ cp.categoryName }}
            </div>
            <div v-if="cp.name != null">
              {{ $t("text.name") }}：{{ cp.name }}
            </div>
            <div v-if="cp.color != null">
              {{ $t("product.color") }}：{{ cp.color }}
            </div>
            <div v-if="cp.size != null">
              {{ $t("product.size") }}：{{ cp.size }}
            </div>
            <div>
              {{ $t("product.rentPrice") }}：{{ cp.rentPrice | currency }}
            </div>
            <div>
              {{ $t("product.salesPrice") }}：{{ cp.salesPrice | currency }}
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
    <div id="printSelectColorSizeDivNoPrice" style="display: none">
      <div
        v-for="(cp, index) in combinationProducts"
        :key="index"
        :style="
          'margin:0 auto; width:400px; text-align:left; font-size: 18px;word-break: break-all;word-wrap: break-word' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <div style="clear: both">
          <div style="float: left; width: 100px">
            <qrcode
              :value="`${cp.productNo}|${cp.color}|${cp.size}|product|`"
              :options="{ width: 100 }"
              :tag="'img'"
            />
          </div>
          <div
            style="
              float: left;
              width: 260px;
              word-break: break-all;
              word-wrap: break-word;
            "
          >
            <div>{{ $t("product.productNo") }}：{{ cp.productNo }}</div>
            <div v-if="cp.name != null">
              {{ $t("text.name") }}：{{ cp.name }}
            </div>
            <div v-if="cp.categoryName != null">
              {{ $t("product.category") }}：{{ cp.categoryName }}
            </div>
            <div v-if="cp.color != null">
              {{ $t("product.color") }}：{{ cp.color }}
            </div>
            <div v-if="cp.size != null">
              {{ $t("product.size") }}：{{ cp.size }}
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
    <div id="printCustomTemplateDiv" style="display: none">
      <div id="printCustomTemplate" />
    </div>
    <div id="printBaseInfoDiv" style="display: none">
      <div
        v-for="(cp, index) in checkedProducts"
        :key="index"
        :style="
          'margin:0 auto; width:600px; text-align:left; font-size: 18px;word-break: break-all;word-wrap: break-word' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            word-wrap: break-word;
            word-break: break-all;
          "
        >
          <tr>
            <td
              colspan="4"
              style="
                border: 1px solid #dfe5ec;
                text-align: center;
                font-size: 18px;
                font-weight: bold;
                height: 40px;
              "
            >
              {{ cp.productNo }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              {{ $t("product.category") }}
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ cp.categoryName }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              {{ $t("product.brand") }}
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ cp.brand }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              {{ $t("product.name") }}
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ cp.name }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              {{ $t("product.unit") }}
            </td>
            <td style="border: 1px solid #dfe5ec">
              {{ cp.unit }}
            </td>
          </tr>
          <tr v-if="cp.images != null">
            <td colspan="4" style="border: 1px solid #dfe5ec">
              <img
                v-if="Util.tranStringToArr(cp.images)[0]"
                style="
                  max-width: 280px;
                  max-height: 400px;
                  vertical-align: top;
                  margin-right: 5px;
                "
                :src="Util.tranStringToArr(cp.images)[0]"
              />
              <img
                v-if="Util.tranStringToArr(cp.images)[1]"
                style="max-width: 280px; max-height: 400px; vertical-align: top"
                :src="Util.tranStringToArr(cp.images)[1]"
              />
            </td>
          </tr>
          <tr v-if="cp.images != null">
            <td colspan="4" style="border: 1px solid #dfe5ec">
              <div
                v-for="(im, imIndex) in Util.tranStringToArr(cp.images)"
                :key="imIndex"
                style="float: left"
              >
                <img
                  v-if="![0, 1].includes(imIndex)"
                  :src="im"
                  width="80"
                  style="width: 80px; margin-right: 5px; vertical-align: top"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #dfe5ec">
              {{ $t("product.introduction") }}
            </td>
            <td colspan="3" style="border: 1px solid #dfe5ec">
              <raw-html :content="cp.introduction" />
            </td>
          </tr>
        </table>
      </div>
    </div>

    <el-dialog
      :title="$t('action.printTag')"
      :close-on-click-modal="false"
      :visible.sync="printSelectColorSizeDF"
      width="60%"
    >
      <el-form ref="printSelectColorSizeForm" label-width="50px">
        <fieldset class="mgb15" v-if="colorsJiaoji.length != 0">
          <legend>
            {{ $t("product.color") }}
            <el-checkbox
              class="mgl10"
              v-model="checkAllColors"
              :indeterminate="isIndeterminateColors"
              @change="handleCheckAllColorsChange"
              >{{ $t("action.checkAll") }}</el-checkbox
            >
            <el-input
              v-model.trim="searchColorsJiaojiName"
              :placeholder="$t('rules.required', [$t('text.name')])"
              style="width: 250px"
              class="mgl5"
              clearable
              size="mini"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchColorsJiaoji"
              />
            </el-input>
          </legend>
          <el-checkbox-group
            size="small"
            v-model="checkedColors"
            @change="handleCheckedColorsChange"
          >
            <el-checkbox
              v-for="color of colorsJiaojiFilter"
              :key="color"
              :label="color"
              style="width: 100px"
              class="mgb10"
            >
              <raw-html-limit-number :content="color" :number="7" />
            </el-checkbox>
          </el-checkbox-group>
        </fieldset>
        <fieldset class="mgb15" v-if="sizesJiaoji.length != 0">
          <legend>
            {{ $t("product.size") }}
            <el-checkbox
              v-model="checkAllSizes"
              :indeterminate="isIndeterminateSizes"
              class="mgl10"
              @change="handleCheckAllSizesChange"
              >{{ $t("action.checkAll") }}</el-checkbox
            >
            <el-input
              v-model.trim="searchSizesJiaojiName"
              :placeholder="$t('rules.required', [$t('text.name')])"
              style="width: 250px"
              class="mgl5"
              clearable
              size="mini"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchSizesJiaoji"
              />
            </el-input>
          </legend>
          <el-checkbox-group
            size="small"
            v-model="checkedSizes"
            @change="handleCheckedSizesChange"
          >
            <el-checkbox
              v-for="size of sizesJiaojiFilter"
              :key="size"
              :label="size"
              style="width: 100px"
            >
              <raw-html-limit-number :content="size" :number="7" />
            </el-checkbox>
          </el-checkbox-group>
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="printSelectColorSizeDFDoing"
          size="small"
          @click="printSelectColorSizeSubmit(false)"
          >{{ $t("text.submit") }}(不带价格)</el-button
        >
        <el-button
          type="success"
          plain
          :loading="printSelectColorSizeDFDoing"
          size="small"
          @click="printSelectColorSizeSubmit(true)"
          >{{ $t("text.submit") }}(带价格)</el-button
        >
        <el-button size="small" @click="printSelectColorSizeDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" @updateInfo="showRowClose" />
    </drawer>

    <drawer
      :title="$t('text.edit')"
      :visible.sync="showEditDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <edit :id="currentRowId" @updateInfo="editRowClose" />
    </drawer>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import Qrcode from "@chenfengyuan/vue-qrcode";
import QRCode from "qrcode";
import PagerConfig from "@/config/pager.js";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import RawHtml from "@/components/RawHtml";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Product from "@/api/product.js";
import Category from "@/api/category.js";
// import PrintTemplate from "@/api/printTemplate.js";
import Brand from "@/api/brand";
import Show from "./show.vue";
import Edit from "./edit.vue";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Qrcode,
    QRCode,
    Show,
    Edit,
    RawHtmlLimitNumber,
    RawHtml,
  },
  data() {
    return {
      Util: Util,
      // 设置只能选择今天以后
      pickerTodayAfterTime: {
        pickerTodayAfterTime(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      pagerConfig: PagerConfig.product,
      pager: {
        currentPage: 1,
        pageSize: PagerConfig.product.defaultPageSize,
        total: 0,
      },
      narrows: [
        [
          {
            label: this.$t("text.special"),
            items: [
              {
                label: this.$t("product.productNoRepeat"),
                key: "productNoRepeat",
                condition: { special: "productNoRepeat" },
                numberFun: Product.repeatCount,
                emitNames: ["productUpdate", "productDelete"],
              },
            ],
          },
          {
            label: this.$t("product.life"),
            items: [
              {
                label: this.$t("yearInfos.yes"),
                key: "overLifeNo",
                condition: { overLife: "no" },
              },
              {
                label: this.$t("yearInfos.no"),
                key: "overLifeYes",
                condition: { overLife: "yes" },
              },
            ],
          },
        ],
      ],

      searchForm: {
        productNo: null,
      },
      materials: [],
      serialNosLoading: false,
      sorter: {
        // sortBy: "product_refreshAt",
        // sortIndicator: "desc",
        sortBy: "product_id",
        sortIndicator: "desc",
      },
      Util: Util,
      cardPattern: true,
      checkedProducts: [],
      checkAllDF: false,
      //
      printTemplatesProduct: [],
      // 打印
      colorsJiaoji: [],
      sizesJiaoji: [],
      printSelectColorSizeDF: false,
      printSelectColorSizeDFDoing: false,
      combinationProducts: [],
      // 颜色
      isIndeterminateColors: false,
      checkedColors: [],
      checkAllColors: false,
      searchColorsJiaojiName: null,
      colorsJiaojiFilter: [],
      // 尺码
      isIndeterminateSizes: false,
      checkedSizes: [],
      checkAllSizes: false,
      searchSizesJiaojiName: null,
      sizesJiaojiFilter: [],

      //
      currentRowId: null,
      currentRowIdx: null,
      showDF: false,
      showEditDF: false,
    };
  },
  computed: {
    implicit() {
      return {
        type: "product",
      };
    },
  },
  created() {
    const self = this;
    if (
      localStorage.getItem("cardPattern") &&
      localStorage.getItem("cardPattern") != null
    ) {
      self.cardPattern = JSON.parse(localStorage.getItem("cardPattern"));
    }
    axios
      .all([
        Category.productCategory(),
        Brand.findByTenantId(),
        // PrintTemplate.findByType({ type: "product" }),
      ])
      .then(
        axios.spread(function (categories, brands) {
          if (categories.status === 200) {
            if (categories.data.length !== 0) {
              self.narrows.push([
                {
                  label: self.$t("menu.categories"),
                  items: categories.data.map((category) => {
                    return {
                      label: category.name,
                      key: category.id,
                      condition: { categoryId: category.id },
                    };
                  }),
                },
              ]);
            }
          } else {
            self.sysError();
          }
          if (brands.status === 200) {
            if (brands.data.length != 0) {
              self.narrows.push([
                {
                  label: self.$t("product.brand"),
                  items: brands.data.map((brand) => {
                    return {
                      label: brand.name,
                      key: brand.id,
                      condition: { brandId: brand.id },
                    };
                  }),
                },
              ]);
            }
          } else {
            self.sysError();
          }
          // if (printTemplatesProduct.status === 200) {
          //   self.printTemplatesProduct = printTemplatesProduct.data;
          // } else {
          //   self.sysError();
          // }
        })
      );
  },
  methods: {
    setSelected() {
      this.setSelectedQty();
      this.checkedProducts =
        (this.$refs.recordsTable &&
          this.$refs.recordsTable.getCheckboxRecords()) ||
        [];
    },
    //
    editRow(row, rowIndex) {
      this.currentRowId = row.id;
      this.currentRowIdx = rowIndex;
      this.showEditDF = true;
    },
    editRowClose() {
      this.loadData();
      this.$eventHub.$emit("productUpdate");
      this.showEditDF = false;
    },

    showRow(row, rowIndex) {
      this.currentRowId = row.id;
      this.currentRowIdx = rowIndex;
      this.showDF = true;
    },
    showRowClose() {
      this.loadData();
      this.showDF = false;
    },
    printBaseInfo() {
      const self = this;
      if (self.checkedProducts.length === 0) {
        self.$message.error(this.$t("prompt.atLeastSelectOneData"));
        return;
      }
      self.print("printBaseInfoDiv");
    },
    printTag(cmd) {
      const self = this;
      if (self.checkedProducts.length === 0) {
        self.$message.error(this.$t("prompt.atLeastSelectOneData"));
        return;
      }
      if (["printQrCodesDiv", "printQrCodesNoPriceDiv"].includes(cmd)) {
        self.print(cmd);
        return;
      }
      if (cmd === "printSelectColorSizeDiv") {
        if (
          self.checkedProducts.length == 1 &&
          self.checkedProducts[0].colors.length == 0 &&
          self.checkedProducts[0].sizes.length == 0
        ) {
          self.$message({
            message: this.$t("prompt.noColorSize"),
            type: "warning",
          });
          return;
        }
        const colorsArr = self.checkedProducts.map((p) => p.colors);
        const sizesArr = self.checkedProducts.map((p) => p.sizes);
        self.colorsJiaoji = self.jiaoji(colorsArr);
        self.colorsJiaojiFilter = self.colorsJiaoji;
        self.sizesJiaoji = self.jiaoji(sizesArr);
        self.sizesJiaojiFilter = self.sizesJiaoji;
        if (self.colorsJiaoji.length === 0 && self.sizesJiaoji.length === 0) {
          this.$message({
            message: this.$t("prompt.noColorSizeIntersection"),
            type: "warning",
          });
          return;
        }
        self.printSelectColorSizeDF = true;
        self.checkedSizes = [];
        self.checkedColors = [];
        self.searchColorsJiaojiName = null;
        self.searchSizesJiaojiName = null;
        return;
      }

      self.printCustomTemplateSubmit(cmd);
    },
    jiaoji(arrs) {
      let jiaoji = arrs.shift();
      for (const arr of arrs) {
        jiaoji = Util.intersection(jiaoji, arr);
      }
      return jiaoji;
    },
    // 颜色
    handleCheckAllColorsChange(val) {
      this.checkedColors = val ? this.colorsJiaojiFilter : [];
      this.checkedColorSize();
    },
    handleCheckedColorsChange(value) {
      const checkedCount = value.length;
      this.checkAllColors = checkedCount === this.colorsJiaojiFilter.length;
      this.isIndeterminateColors =
        checkedCount > 0 && checkedCount < this.colorsJiaojiFilter.length;
      this.checkedColorSize();
    },
    searchColorsJiaoji() {
      this.checkedColors = [];
      this.checkAllColors = false;
      this.isIndeterminateColors = false;
      if (
        this.searchColorsJiaojiName == null ||
        this.searchColorsJiaojiName == ""
      ) {
        this.colorsJiaojiFilter = this.colorsJiaoji;
        return;
      }
      this.colorsJiaojiFilter = this.colorsJiaoji.filter(
        (c) => c.indexOf(this.searchColorsJiaojiName) != -1
      );
    },
    // 尺码
    handleCheckAllSizesChange(val) {
      this.checkedSizes = val ? this.sizesJiaojiFilter : [];
      this.checkedColorSize();
    },
    handleCheckedSizesChange(value) {
      const checkedCount = value.length;
      this.checkAllSizes = checkedCount === this.sizesJiaojiFilter.length;
      this.isIndeterminateSizes =
        checkedCount > 0 && checkedCount < this.sizesJiaojiFilter.length;
      this.checkedColorSize();
    },
    searchSizesJiaoji() {
      this.checkedSizes = [];
      this.checkAllSizes = false;
      this.isIndeterminateSizes = false;
      if (
        this.searchSizesJiaojiName == null ||
        this.searchSizesJiaojiName == ""
      ) {
        this.sizesJiaojiFilter = this.sizesJiaoji;
        return;
      }
      this.sizesJiaojiFilter = this.sizesJiaoji.filter(
        (c) => c.indexOf(this.searchSizesJiaojiName) != -1
      );
    },

    checkedColorSize() {
      const self = this;
      self.combinationProducts = [];
      for (const product of self.checkedProducts) {
        //
        if (self.checkedColors.length !== 0 && self.checkedSizes.length !== 0) {
          for (const color of self.checkedColors) {
            for (const size of self.checkedSizes) {
              self.combinationProducts.push({
                id: product.id,
                uuid: product.uuid,
                productNo: product.productNo,
                categoryName: product.categoryName,
                brand: product.brand,
                salesPrice: product.salesPrice,
                rentPrice: product.rentPrice,
                color: color,
                size: size,
              });
            }
          }
        }
        //
        if (self.checkedColors.length !== 0 && self.checkedSizes.length === 0) {
          for (const color of self.checkedColors) {
            self.combinationProducts.push({
              id: product.id,
              uuid: product.uuid,
              productNo: product.productNo,
              name: product.name,
              categoryName: product.categoryName,
              brand: product.brand,
              salesPrice: product.salesPrice,
              rentPrice: product.rentPrice,
              color: color,
              size: null,
            });
          }
        }
        //
        if (self.checkedColors.length === 0 && self.checkedSizes.length !== 0) {
          for (const size of self.checkedSizes) {
            self.combinationProducts.push({
              id: product.id,
              uuid: product.uuid,
              productNo: product.productNo,
              name: product.name,
              categoryName: product.categoryName,
              brand: product.brand,
              salesPrice: product.salesPrice,
              rentPrice: product.rentPrice,
              color: null,
              size: size,
            });
          }
        }
      }
    },
    printSelectColorSizeSubmit(type) {
      this.printSelectColorSizeDF = false;
      this.checkedProducts = [];
      if (type == true) {
        this.print("printSelectColorSizeDiv");
      } else {
        this.print("printSelectColorSizeDivNoPrice");
      }
    },
    async printCustomTemplateSubmit(cmd) {
      const self = this;
      let customPrintContent = "";
      for (const checkedProduct of self.checkedProducts) {
        let customPrintContentProduct = cmd.content;
        customPrintContentProduct = customPrintContentProduct.replace(
          /\${货号}/g,
          checkedProduct.productNo
        );

        let qrRes = await QRCode.toDataURL(self.qrCodes(checkedProduct));
        customPrintContentProduct = customPrintContentProduct.replace(
          /\${货号二维码}/g,
          "<img src=" + qrRes + " style='width: 100px'/>"
        );

        customPrintContentProduct = customPrintContentProduct.replace(
          /\${单位}/g,
          checkedProduct.unit || ""
        );
        customPrintContentProduct = customPrintContentProduct.replace(
          /\${分类}/g,
          checkedProduct.categoryName || ""
        );

        customPrintContentProduct = customPrintContentProduct.replace(
          /\${品牌}/g,
          checkedProduct.brand || ""
        );
        customPrintContentProduct = customPrintContentProduct.replace(
          /\${成本价}/g,
          "¥" + checkedProduct.costPrice || ""
        );
        customPrintContentProduct = customPrintContentProduct.replace(
          /\${售价}/g,
          "¥" + checkedProduct.salesPrice || ""
        );
        customPrintContentProduct = customPrintContentProduct.replace(
          /\${租赁价}/g,
          "¥" + checkedProduct.rentPrice || ""
        );
        customPrintContent = customPrintContent + customPrintContentProduct;
      }

      window.document.getElementById("printCustomTemplate").innerHTML =
        customPrintContent;
      self.print("printCustomTemplateDiv");
    },
    print(type) {
      const newWindow = window.open("_blank");
      const codestr = document.getElementById(type).innerHTML;
      newWindow.document.write(codestr);
      // newWindow.document.body.style.margin = 0;
      newWindow.document.close();
    },
    qrCodes(cp) {
      return cp.productNo;
    },

    // 下载
    download(type) {
      const self = this;
      if (type.indexOf("checked") !== -1) {
        if (
          self.checkedProducts.length === 0 ||
          self.checkedProducts.length > 100000
        ) {
          self.$message.error(this.$t("prompt.downloadDataRange100000"));
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: 100000,
          ids: self.checkedProducts.map((c) => c.id),
          exportWithImg: type.indexOf("WithImg") !== -1,
        };
        self.downloadData(data);
      } else {
        if (self.pager.total === 0 || self.pager.total > 100000) {
          self.$message.error(this.$t("prompt.downloadDataRange100000"));
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = 100000;
        Vue.set(data, "exportWithImg", type.indexOf("WithImg") !== -1);
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      Product.exportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.checkedProducts = [];
          self.loadData();
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    // 批量删除
    batchDelete() {
      const self = this;
      if (self.checkedProducts.length === 0) {
        self.$message({
          message: this.$t("prompt.atLeastSelectOneData"),
          type: "warning",
        });
        return;
      }
      Product.batchDelete(self.checkedProducts.map((c) => c.id)).then(function (
        res
      ) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 删除
    deleteRow(row) {
      const self = this;
      Product.delete(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("productDelete");
        } else {
          self.sysError();
        }
      });
    },

    checkedProduct() {
      this.selectRecordQty = this.checkedProducts.length;
    },

    checkAll() {
      if (this.checkAllDF === true) {
        this.checkedProducts = this.records;
      } else {
        this.checkedProducts = [];
      }
      this.selectRecordQty = this.checkedProducts.length;
    },

    cardPatternChange() {
      localStorage.setItem("cardPattern", this.cardPattern);
      this.checkedProducts = [];
      this.checkAllDF = false;
      this.selectRecordQty = this.checkedProducts.length;
    },
    dataProvider(params) {
      return Product.search(params);
    },
  },
};
</script>
<style scoped>
.image-div {
  height: 200px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.product-checkbox-div {
  position: absolute;
  width: 16%;
}
.product-label-div {
  position: absolute;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}
.product-label {
  background: #d83732;
  border: 1px solid #d83732;
  margin: 0 0 1px 0;
  text-align: left;
  padding: 2px 6px 2px 2px;
  font-size: 12px;
  display: inline-block !important;
  display: inline;
  border-bottom-right-radius: 40px;
  border-top-right-radius: 40px;
  color: #fff;
  opacity: 0.8;
  /* width: auto; */
  /* max-width: 80px; */
  /* overflow: hidden; */
}
</style>